import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

/**
 * THis is the function that renders hidden input element
 *
 * @param {object} root0 props to be passed
 * @param {string} root0.currentItem product variant id
 * @param {string} root0.productId product unique id
 * @param {string} root0.currencyCode current currency code
 * @param {object} root0.deliveryDetailsData object giving the details of the product shipments
 * @param {string} root0.countryGeoId determines the country for which the product belongs
 * @param {boolean} root0.isMobile boolean flag to check if is Mobile
 * @param {number} root0.defaultPrice defaultPrice of product
 * @param {string} root0.skuCode skucode for the product
 * @param {string} root0.primaryCategoryId category id for the product
 * @param {string} root0.productName This is the product name
 * @param {string} root0.primaryKeywordId primaryKeywordId for the product
 * @param {string} root0.fnpSalesChannelEnumId fnpSalesChannelEnumId
 * @returns {React.ReactElement} jsx for the pdp page.
 */
const HiddenInputs = ({
  productDetails = {},
  currentItem = {},
  currencyCode = "",
  deliveryDetailsData = {},
  isMobile = false,
  fnpSalesChannelEnumId = "",
}) => {
  const [occasionTag, setOccasionTag] = useState("");
  const [productCategory, setProductCategory] = useState("Gift");
  const selectedCurrency = useSelector((state) => state.currencyList?.userSelectedCurrency?.currencyCode);
  const shippingSlot = deliveryDetailsData?.timeSlots?.timeSlots;

  useEffect(() => {
    const url = new URL(window.location.href);
    setOccasionTag(url.searchParams.get("OCCASION_TAGS") ? url.searchParams.get("OCCASION_TAGS") : "_NA_");
    if (document.referrer.length > 0) {
      const refUrlString = new URL(document.referrer);
      setProductCategory(refUrlString.pathname !== url.pathname ? refUrlString.pathname : "Gift");
    }
  }, []);

  return (
    <>
      <input
        type="hidden"
        name="add_product_id"
        value={currentItem?.productId || productDetails?.productId || ""}
        id="addProductId"
      />
      <input type="hidden" name="product_id" id="productId" value={productDetails?.productId || ""} />
      <input type="hidden" name="baseProductId" id="baseProductId" value={productDetails?.productId || ""} />
      <input
        type="hidden"
        name="primaryKeywordId"
        id="primaryKeywordId"
        value={currentItem?.primaryKeywordId || "gifts"}
      />
      <input name="quantity" id="quantity" value="1" size="4" maxLength="4" type="hidden" />
      <input type="hidden" name="vendorId" id="vendorId" value="" />
      <input
        type="hidden"
        value={deliveryDetailsData?.selectedDate?.replace(/-/g, "/") || ""}
        id="productDeliveryDate"
      />
      <input
        type="hidden"
        value={currencyCode === "₹" ? "" : currencyCode || selectedCurrency || ""}
        name="selectedCurrency"
        className="selectedCurrency"
      />
      <input
        type="hidden"
        value={deliveryDetailsData?.selectedDate || ""}
        id="itemDesiredDeliveryDate"
        name="itemDesiredDeliveryDate"
      />
      <input
        type="hidden"
        value={shippingSlot?.isDynamic && shippingSlot?.isDynamic !== "N" ? shippingSlot?.startTime?.slice(0, 5) : ""}
        id="dynamicStartTime"
        name="dynamicStartTime"
      />
      <input
        type="hidden"
        value={shippingSlot?.isDynamic && shippingSlot?.isDynamic !== "N" ? shippingSlot?.endTime?.slice(0, 5) : ""}
        id="dynamicEndTime"
        name="dynamicEndTime"
      />
      <input type="hidden" value="" id="itemDesiredDeliveryDatesList" name="itemDesiredDeliveryDatesList" />
      <input type="hidden" value="" id="pinCode" name="pinCode" />
      <input type="hidden" value="" id="matchedPincode" name="matchedPincode" />
      <input type="hidden" value="" id="deliveryLocation" name="deliveryLocation" />
      <input type="hidden" value={productDetails.countryGeoId || ""} id="countryGeoId" name="countryGeoId" />
      <input type="hidden" id="occasion" name="occasion" value={occasionTag} />
      <input type="hidden" value="" id="personalizedOptions" name="personalizedOptions" />
      <input type="hidden" name="add_category_id" id="productCategoryId" value={productCategory} />
      <input type="hidden" value={fnpSalesChannelEnumId} id="fnpSalesChannelEnumId" name="fnpSalesChannelEnumId" />
      {isMobile && (
        <>
          <input
            type="hidden"
            name="defaultProductPrice"
            value={currentItem?.productPrice?.defaultPrice ?? ""}
            id="defaultProductPrice"
          />
          <input type="hidden" name="sku" value={currentItem?.skuCode || ""} id="productsku" />
          <input type="hidden" name="price" value={currentItem?.productPrice?.price ?? ""} id="price" />
          <input type="hidden" name="productName" value={currentItem?.productName || ""} id="productName" />
          <input type="hidden" name="decodedCustomerId" value="" id="CRMID_TRACK" />
          <input type="hidden" name="add_category_id" id="productCategoryId" value={productCategory} />
          <input
            type="hidden"
            name="primaryCategoryId"
            value={currentItem?.primaryCategoryId || ""}
            id="primaryCategoryId"
          />
        </>
      )}
    </>
  );
};

HiddenInputs.propTypes = {
  productDetails: PropTypes.objectOf(PropTypes.any),
  currentItem: PropTypes.objectOf(PropTypes.any),
  currencyCode: PropTypes.string,
  deliveryDetailsData: PropTypes.objectOf(PropTypes.any),
  isMobile: PropTypes.bool,
  fnpSalesChannelEnumId: PropTypes.string,
};

export default HiddenInputs;
